import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsKambiRendered } from '../Store/selectors'

let hasPageRendered = false

export const useShouldShowSpinner = (): boolean => {
  const isKambiRendered = useSelector(selectIsKambiRendered)

  const [shouldShowSpinner, setShouldShowSpinner] = React.useState(false)

  React.useEffect(() => {
    if (hasPageRendered) return undefined

    if (isKambiRendered) {
      setShouldShowSpinner(false)
      hasPageRendered = true
    } else {
      setShouldShowSpinner(true)
    }
  }, [isKambiRendered])

  return shouldShowSpinner
}
